// extracted by css-extract-rspack-plugin
export default {"hovering":"hovering-XGy_Hz"};